// import React from "react";
// import { Outlet } from "react-router-dom";
// import { RequireAuth } from "@ippon/shared-auth";

// const PrivateRoute: React.FC = () => {
//   return (
//     <RequireAuth>
//       <Outlet />
//     </RequireAuth>
//   );
// };

// export default PrivateRoute;
import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { CustomAuthLoading } from "@ippon/shared-auth";
import { setRedirectPath, fetchMe } from "../store/authSlice";
import { AppDispatch } from "../store";
import {
  isAuthenticated,
  getRole,
  getRefreshToken,
  savePostLoginRedirect,
} from "../utils/authUtils";
import { tryRecoverAuth } from "../config/axios";

type AuthPhase = "ok" | "recovering" | "denied";

// 初期判定: token 有効なら ok、無いが refreshToken 残ってれば復旧試行、それ以外は denied
const decideInitialPhase = (): AuthPhase => {
  if (isAuthenticated()) return "ok";
  if (getRefreshToken()) return "recovering";
  return "denied";
};

const PrivateRoute = ({ allowedRoles }: { allowedRoles?: string[] }) => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const [phase, setPhase] = useState<AuthPhase>(decideInitialPhase);

  // [RECOVERY] token が無いが refreshToken だけ残っている状態からの自動復旧。
  // 1 日 expiry の token cookie だけ先に消えるケース (日跨ぎ等) を救う。
  useEffect(() => {
    if (phase !== "recovering") return;
    let cancelled = false;
    tryRecoverAuth().then((ok) => {
      if (cancelled) return;
      setPhase(ok && isAuthenticated() ? "ok" : "denied");
    });
    return () => {
      cancelled = true;
    };
  }, [phase]);

  // ログイン済みになったら /auth/me を取得し、capabilities を store に載せる（can() 出し分け用）
  useEffect(() => {
    if (phase === "ok") {
      dispatch(fetchMe());
    }
  }, [phase, dispatch]);

  // 黒い膜は出さず、ログイン画面と同じロゴとスピナーを白い画面に出す
  if (phase === "recovering") {
    return <CustomAuthLoading label="物件管理" />;
  }

  if (phase === "denied") {
    dispatch(setRedirectPath(location.pathname + location.search));
    // 再ログイン後にこの画面へ戻す (フルリロード耐性のため sessionStorage にも保存)。
    savePostLoginRedirect(location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  // phase === "ok"
  const userRole = getRole() || "";
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
